export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VuesticTreeNode.vue?vue&type=template&id=44b3f842"


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-tree-view/VuesticTreeNode.vue?vue&type=template&id=44b3f842
// module id = qDFk
// module chunks = 41